import React from "react";
import { ProducaoBebidasProvider } from "./context/ProducaoBebidasContext";
import ProducaoBebidasContent from "./components/ProducaoBebidasContent";

const ProducaoBebidas: React.FC = () => {
  return (
    <ProducaoBebidasProvider>
      <ProducaoBebidasContent />
    </ProducaoBebidasProvider>
  );
};

export default ProducaoBebidas;
